var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 86,
    viewBox: "0 0 144 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8451 2H7C4.23858 2 2 4.23858 2 7V79C2 81.7614 4.23857 84 7 84H137C139.761 84 142 81.7614 142 79V7C142 4.23858 139.761 2 137 2H103.62C100.858 2 98.6197 4.23858 98.6197 7V38.5C98.6197 41.2614 96.3811 43.5 93.6197 43.5H52.8451C50.0836 43.5 47.8451 41.2614 47.8451 38.5V7C47.8451 4.23858 45.6065 2 42.8451 2Z",
    fill: "#AFDB28",
    fillOpacity: 0.2,
    stroke: "#22A156",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0303 9.46967C34.7374 9.17678 34.2626 9.17678 33.9697 9.46967L29.1967 14.2426C28.9038 14.5355 28.9038 15.0104 29.1967 15.3033C29.4896 15.5962 29.9645 15.5962 30.2574 15.3033L34.5 11.0607L38.7426 15.3033C39.0355 15.5962 39.5104 15.5962 39.8033 15.3033C40.0962 15.0104 40.0962 14.5355 39.8033 14.2426L35.0303 9.46967ZM33.9697 37.5303C34.2626 37.8232 34.7374 37.8232 35.0303 37.5303L39.8033 32.7574C40.0962 32.4645 40.0962 31.9896 39.8033 31.6967C39.5104 31.4038 39.0355 31.4038 38.7426 31.6967L34.5 35.9393L30.2574 31.6967C29.9645 31.4038 29.4896 31.4038 29.1967 31.6967C28.9038 31.9896 28.9038 32.4645 29.1967 32.7574L33.9697 37.5303ZM33.75 10L33.75 37L35.25 37L35.25 10L33.75 10Z",
    fill: "#22A156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3636 30.5H10.4347L10.4347 15.9545H15.4631C16.9072 15.9545 18.1477 16.2457 19.1847 16.8281C20.2263 17.4058 21.0265 18.2367 21.5852 19.321C22.1439 20.4053 22.4233 21.7027 22.4233 23.2131C22.4233 24.7282 22.1416 26.0303 21.5781 27.1193C21.0194 28.2083 20.2121 29.044 19.1563 29.6264C18.1051 30.2088 16.8409 30.5 15.3636 30.5ZM13.0696 28.2202H15.2358C16.2491 28.2202 17.0942 28.0355 17.7713 27.6662C18.4484 27.2921 18.9574 26.7358 19.2983 25.9972C19.6392 25.2538 19.8097 24.3258 19.8097 23.2131C19.8097 22.1004 19.6392 21.1771 19.2983 20.4432C18.9574 19.7045 18.4531 19.1529 17.7855 18.7884C17.1226 18.419 16.2988 18.2344 15.3139 18.2344H13.0696L13.0696 28.2202Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUd);
export default __webpack_public_path__ + "static/media/ud.67eb976533fe6af585e10adb7af1655b.svg";
export { ForwardRef as ReactComponent };